import {BasketState}				from '../../redux/basket/interface';
import {User}								from '../../redux/user/interface';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Values = string | User | BasketState | null | any

export function setLocalStorage(key: string, value: Values) {
	if (key === 'user' && value?.isLoad)
		value.isLoad = false;
	localStorage.setItem(key, JSON.stringify(value));
}

export function	getLocalStorage(key: string) {
	try {
		return JSON.parse(localStorage.getItem(key) || '');
	} catch (e) {
		return undefined;
	}
}
